import CheckIcon from 'assets/images/funds/check_circle.svg'
import ErrorIcon from 'assets/images/funds/error_outline.svg'
import Error from 'assets/images/funds/error.svg'
export const MoneyPoolsStatus: {
    [key: string]: {
        title: string
        icon: string
        color: string
        bgColor: string
    }
} = {
    ps_overpaid: {
        title: 'پرداخت شده',
        icon: CheckIcon,
        color: '#13BF86',
        bgColor: '#E7F8F3',
    },
    ps_paid: {
        title: 'پرداخت شده',
        icon: CheckIcon,
        color: '#13BF86',
        bgColor: '#E7F8F3',
    },
    ps_unpaid: {
        title: 'در انتظار پرداخت',
        icon: ErrorIcon,
        color: '#D99711',
        bgColor: '#FFF7E7',
    },
    ps_delayed: {
        title: 'پرداخت نشده',
        icon: Error,
        color: '#FF4C4C',
        bgColor: '#FFEDED',
    },

    paid: {
        title: 'پرداخت شده',
        icon: CheckIcon,
        color: '#13BF86',
        bgColor: '#E7F8F3',
    },

    unpaid: {
        title: 'در انتظار پرداخت',
        icon: ErrorIcon,
        color: '#D99711',
        bgColor: '#FFF7E7',
    },

    delayed:{
        title:"تاخیر در پرداخت",
        icon: Error,
        color: '#FF4C4C',
        bgColor: '#FFEDED',
    }

}

export const MoneyPoolCashin = 'cn'
export const MoneyPoolCashout = 'ct'

export const MoneyPoolCashinTypePortion = 'cnp'
export const MoneyPoolCashinTypeCustom = 'cnc'
export const MoneyPoolCashinTypePortionRecord = 'cnpr'
export const MoneyPoolCashoutCustom = 'ctc'
export const MoneyPoolCashoutTypeLoan = 'ctl'
export const MoneyPoolCashinTypeRepayment = 'cnr'

export const MoneyPoolTransactionTypes: { [key: string]: string } = {
    [MoneyPoolCashinTypePortion]: 'واریز حق عضویت',
    [MoneyPoolCashinTypeCustom]: 'افزایش موجودی',
    [MoneyPoolCashinTypePortionRecord]: 'واریز حق عضویت',
    [MoneyPoolCashoutCustom]: 'برداشت متفرقه',
    [MoneyPoolCashoutTypeLoan]: 'اعطای وام',
    [MoneyPoolCashinTypeRepayment]: 'پرداخت قسط',
}

export const MoneyPoolDeedTypeTransactional = "dtt"
export const MoneyPoolDeedTypeRecord = "dtr"

export const MoneyPoolCashoutReason: { [key: number]: string } = {
    0: 'برداشت سرمایه شخصی',
    1: 'عودت قرض مدت دار، واریز اشتباه یا اضافه',
    2: 'برنامه های جانبی فرهنگی و امور خیریه \\n بلاعوض',
    3: 'تامین مالی هزینه کرد از محل درآمد صندوق',
    4: 'سایر',
}

export const ctxMnp: { [key: string]: string } = {
    cnp: 'حق عضویت',
    cnr: 'بازپرداخت وام',
    cnc: 'افزایش موجودی',
    ctl: 'وام',
    ctc: 'متفرقه',
}
